document.addEventListener('DOMContentLoaded', () => {
    const priceMatchModalTrigger = document.querySelector('[data-modal-trigger="price-match"]');
    if (!priceMatchModalTrigger) return;
    const priceMatchModal = document.querySelector('[data-modal="price-match"]');
    const sizeRadios = priceMatchModalTrigger.closest('[product-details]').querySelectorAll('[name="Size"], [name="size"]');
    if (priceMatchModalTrigger && priceMatchModal && sizeRadios.length > 0) {
        priceMatchModalTrigger.addEventListener('click', () => {
            // Find selected size
            let selectedSize = null;
            sizeRadios.forEach(radio => {
                if (radio.checked) {
                    selectedSize = radio.value;
                }
            });
            if (selectedSize) {
                // Find input of size and add value of selected size
                const sizeInput = priceMatchModal.querySelector('[name="contact[size]"]');
                if (sizeInput) {
                    sizeInput.value = selectedSize;
                }
            }
        });
    }

    // Check URL has the anchor link #price-match-form and open the modal by adding active class
    if (window.location.hash === '#price-match-form' && priceMatchModal) {
        priceMatchModal.classList.add('active');
    }
});